import { AxTabbedBase } from '@theme/ax-tabbed-base';

/**
 * Mixed content blocks — Swiper-based carousel/grid that mixes 3 block types:
 * article, media_card, push_card. No tabs; extends AxTabbedBase only for the
 * Swiper init + arrows sync (tab-related refs are absent and AxTabbedBase
 * handles their absence gracefully via optional chaining).
 *
 * @extends {AxTabbedBase}
 */
class AxContentBlocksComponent extends AxTabbedBase {
  static bemPrefix = 'ax-content-blocks';
}

customElements.define('ax-content-blocks-component', AxContentBlocksComponent);
